import { createStore, combineReducers } from 'redux';
import {
  reducer as homeHubReducer,
  NAME as homeHubName,
} from 'data/homeHub/redux';
import {
  reducer as userDataReducer,
  NAME as userDataName,
} from 'data/user/redux';
import {
  reducer as inviterReducer,
  NAME as inviterDataName,
} from 'data/inviter/redux';
import {
  reducer as homeMixReducer,
  NAME as homeMixDataName,
} from 'data/homeMix/redux';

const reducers = {
  [homeHubName]: homeHubReducer,
  [userDataName]: userDataReducer,
  [inviterDataName]: inviterReducer,
  [homeMixDataName]: homeMixReducer,
};

const rootReducer = combineReducers(reducers);

export type RootState = ReturnType<typeof rootReducer>;

const store = createStore(rootReducer, {});

export default store;
